import React from "react";

/**
 * Plainly brand mark — custom, original SVG.
 * Owned by Limitless Legacy Consulting LLC. No third-party license dependencies.
 *
 * Variants:
 *   • <PlainlyMark />              → light mark on dark background tile (header use)
 *   • <PlainlyMark inverted />     → dark mark on light tile
 *   • <PlainlyMark monochrome />   → drops the coral accent (for tiny sizes / fallback)
 *   • <PlainlyMark bare />         → no tile background; renders mark on transparent
 */
export function PlainlyMark({
  className = "w-8 h-8",
  inverted = false,
  monochrome = false,
  bare = false,
  title = "Plainly",
}) {
  const tile = inverted ? "#F7F5F0" : "#1E392A";
  const ink = inverted ? "#1E392A" : "#F7F5F0";
  const accent = monochrome ? ink : "#E27D60";

  return (
    <svg
      role="img"
      aria-label={title}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={className}
    >
      <title>{title}</title>
      {!bare && (
        <rect width="64" height="64" rx="14" fill={tile} />
      )}

      {/* Stem of the P */}
      <rect x="12" y="13" width="6" height="38" rx="3" fill={ink} />

      {/* Bowl of the P — open circle */}
      <circle
        cx="30"
        cy="23"
        r="12"
        stroke={ink}
        strokeWidth="6"
        fill="none"
      />

      {/* Coral spark — 4-point twinkle reading as "insight" */}
      <path
        d="M53 7 L54.8 11.2 L59 13 L54.8 14.8 L53 19 L51.2 14.8 L47 13 L51.2 11.2 Z"
        fill={accent}
      />
    </svg>
  );
}

/**
 * Full Plainly wordmark — mark + name. Useful for footer / share cards.
 */
export function PlainlyWordmark({ className = "h-8", monochrome = false }) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <PlainlyMark className="w-8 h-8" monochrome={monochrome} title="Plainly" />
      <span className="font-display text-xl text-[#1E392A]">Plainly</span>
    </div>
  );
}

export default PlainlyMark;
